import { css } from 'glamor'
import * as PropTypes from 'prop-types'
import * as React from 'react'

import { useTheme } from '../../theme'

import getStyles from './styles'

interface ISnackbarContainerProps {
  snackbars: any[]
  children: React.ReactNode
}

export const SnackbarContainer = ({ children, snackbars }: ISnackbarContainerProps) => {
  return (
    <>
      {snackbars && snackbars.length > 0 && <SnackbarWrapper snackbars={snackbars} />}
      {children}
    </>
  )
}

SnackbarContainer.displayName = 'SnackbarContainer'
SnackbarContainer.propTypes = {
  snackbars: PropTypes.array,
  children: PropTypes.node,
}

interface ISnackbarWrapperProps {
  snackbars: any[]
}

const SnackbarWrapper: React.FC<ISnackbarWrapperProps> = ({ snackbars }) => {
  const styles = getStyles(useTheme())
  return (
    <div {...css(styles.wrapper.base)}>
      <div {...css(styles.innerWrapper.base)}>
        {snackbars.map((Snack, i) => (
          <div
            key={React.isValidElement(Snack) ? Snack.key : Snack.__id}
            {...css({
              ...styles.snackbar.base,
              order: snackbars.length - i,
            })}
          >
            {React.isValidElement(Snack) ? Snack : <Snack />}
          </div>
        ))}
      </div>
    </div>
  )
}

SnackbarWrapper.propTypes = {
  snackbars: PropTypes.array.isRequired,
}
